import { isPresent } from 'utils/isPresent';
import React, {PureComponent} from 'react';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import {connect} from "react-redux";
import ProAvatar from "../../ProAvatar.js.jsx";
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography"
import List from "housecall-ui/dist/DesignSystem/DataDisplay/List/List"
import ListItem from "housecall-ui/dist/DesignSystem/DataDisplay/List/ListItem";
import ListItemIcon from "housecall-ui/dist/DesignSystem/DataDisplay/List/ListItemIcon";
import ListItemText from "housecall-ui/dist/DesignSystem/DataDisplay/List/ListItemText";
import {FetchData} from "../../Common/Data/DataFetcher";
import {fetchTaskEvents, getTaskEvents} from "./TaskEventsData";

import moment from 'moment-timezone';

const styles = theme => ({
    textRoot: {
        padding: 4
    }
});

@connect(
    (state, ownProps) => ({taskEvents: getTaskEvents(state, ownProps)}),
    dispatch => ({})
)


@withStyles(styles)
@FetchData(fetchTaskEvents, true)
export default class TaskEvents extends PureComponent {

    render() {
        return <div>
            <List component="div">
                {this.props.taskEvents.map((event, index) => {
                    return (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <ProAvatar has_avatar={isPresent(event.avatar)}
                                           size={40}
                                           avatar={event.avatar}
                                           backgroundColor={event.who_color}
                                           initials={event.who_name_initials}
                                           useLatestMaterialUI
                                />
                            </ListItemIcon>
                            <ListItemText classes={{root: this.props.classes.textRoot}}
                                          primary={<Typography variant='body1'>{event.message}</Typography>}
                                          secondary={<Typography
                                              variant='caption'>{moment.utc(event.when).format('ddd M/DD/YY h:mma')}</Typography>}/>
                        </ListItem>
                    )
                })
                }
            </List>
        </div>
    }
}
